/* eslint-disable */
export interface ConfigItem {
  id: string,
  title: string,
  desc?: string,
  commands?: string[],
  images?: string[],
  children?: ConfigItem[]
}
export const BaseLineConfig: ConfigItem[] = [
  {
    id: '101',
    title: '101、杂项安全配置',
    desc: '主要涉及日志配置',
    children: [
      {
        id: '101-1',
        title: '101.1 日志系统检测',
        children: [{
          id: '101-1-1',
          title: '101.1.1 rsyslog检测修复',
          commands: [
            'Centos :   sudo yum install rsyslog',
            'Debain:    sudo apt install rsyslog'
          ]
        }]
      },
      {
        id: '101-2',
        title: '101.2 日志系统配置检测',
        children: [{
          id: '101-2-1',
          title: '101.2.1 /var/log/的权限是否已经正确配置',
          desc: '对日志文件进行审计 \n修复方式：利用 chmod  /var/log 文件夹所不符合的文件。',
          commands: [
            '#查看/var/log下不符合规则的文件',
            'ls -l /var/log/ | grep "\\-r\\w-r\\w-r--\\|\\-\\w\\w\\w\\w\\wx\\w\\w\\w\\|\\-\\w\\w\\w\\w\\w\\w\\ww\\w\\|\\-\\w\\w\\w\\w\\w\\wr\\w\\w\\|\\-\\w\\w\\w\\w\\w\\w\\w\\wx"',
            '#如果找不到文件就是异常',
            'sudo chmod 664 /var/log/wtmp',
            '#或者 sudo chmod 664 /var/log/lastlog'
          ]
        }]
      },
      {
        id: '101-3',
        title: '101.3 定时任务安全配置',
        children: [{
          id: '101-3-1',
          title: '101.3.1 定时任务 cron 黑名单检测',
          desc: '修复方式：删除黑名单配置  /etc/cron.deny',
          commands: [
            'sudo rm /etc/cron.deny'
          ]
        }, {
          id: '101-3-2',
          title: '101.3.2 定时任务 cron 白名单检测',
          desc: '修复方式：root 创建 /etc/cron.allow 文件',
          commands: [
            'ls /etc/cron.allow',
            '#如果存在',
            'sudo chown root:root /etc/cron.allow',
            'sudo chmod 600 /etc/cron.allow',
            '#如果不存在',
            'sudo touch /etc/cron.allow'
          ]
        }, {
          id: '101-3-3',
          title: '101.3.3 定时任务 at 白名单检测',
          desc: '修复方式：root 创建 /etc/at.allow 文件',
          commands: [
            'sudo touch /etc/at.allow'
          ]
        }]
      }, {
        id: '101-4',
        title: '101.4 audit 审计相关配置',
        children: [{
          id: '101-4-1',
          title: '101.4.1 审计规则系统检测',
          commands: [
            '#Centos:',
            'sudo yum install auditd',
            '#Debain: ',
            'sudo apt install auditd'
          ]
        }, {
          id: '101-4-2',
          title: '101.4.2 audit 规则文件检测',
          desc: '修复方式：root 创建 /etc/audit/rules.d/audit.rules 文件',
          commands: [
            'sudo touch /etc/audit/rules.d/audit.rules'
          ]
        }, {
          id: '101-4-3',
          title: '101.4.3 审计规则 utmp 检测',
          commands: [
            '编辑文件  /etc/audit/rules.d/audit.rules 最后增加 -w /var/run/utmp -p wa -k session',
            '要以-w开头'
          ]
        }, {
          id: '101-4-4',
          title: '101.4.4 审计规则 wtmp 检测',
          commands: [
            '编辑文件  /etc/audit/rules.d/audit.rules 最后增加 -w /var/log/wtmp -p wa -k logins',
            '要以-w开头'
          ]
        }, {
          id: '101-4-5',
          title: '101.4.5 审计规则 btmp 检测',
          commands: [
            '编辑文件  /etc/audit/rules.d/audit.rules 最后增加 -w /var/log/btmp -p wa -k logins',
            '要以-w开头'
          ]
        }]
      }
    ]
  }, {
    id: '102',
    title: '102、SSHD 类检测',
    children: [{
      id: '102-1',
      title: '102.1 /etc/ssh/sshd_config 权限是否正确配置',
      children: [{
        id: '102-1-1',
        title: '102.1.1 sshd 配置文件检测',
        desc: '修复方式：利用 chmod chgrp 修增 sshd_config 的用户和用户组',
        commands: [
          'sudo chmod 644 /etc/ssh/sshd_config',
          'sudo chown root:root /etc/ssh/sshd_config',
          '#如果没有文件执行 sudo apt install openssh-server'
        ]
      }]
    }, {
      id: '102-2',
      title: '102.2 SSH 重试次数是否限制',
      children: [{
        id: '102-2-1',
        title: '102.2.1 SSH 重试次数是否限制',
        desc: '修复方式：MaxAuthTries 设置为小于等于4',
        commands: [
          'vim /etc/ssh/sshd_config',
          '#打开文件找到 MaxAuthTries 取消注释并设置为 4 wq 保存'
        ]
      }]
    }, {
      id: '102-3',
      title: '102.3 PermitEmptyPasswords、PermitUserEnvironment 是否已禁用',
      children: [{
        id: '102-3-1',
        title: '102.3.1 PermitEmptyPasswords 限制空密码登录',
        desc: '修复方式：PermitEmptyPasswords 设置为 no',
        commands: [
          'vim /etc/ssh/sshd_config',
          '#打开文件找到 PermitEmptyPasswords 取消注释并设置为 no wq 保存'
        ]
      }, {
        id: '102-3-2',
        title: '102.3.2 PermitUserEnvironment 传递客户端环境变量',
        desc: '修复方式：PermitUserEnvironment 设置为 no',
        commands: [
          'vim /etc/ssh/sshd_config',
          '#打开文件找到 PermitUserEnvironment 取消注释并设置为 no wq 保存'
        ]
      }]
    }, {
      id: '102-4',
      title: '102.4 加密算法是否已经启用',
      children: [{
        id: '102-4-1',
        title: '102.4.1 加密算法是否已经启用',
        desc: '修复方式：从新安装 sshd 服务',
        commands: [
          'apt update && apt install openssh-server'
        ]
      }]
    }, {
      id: '102-5',
      title: '102.5 SSH 空置是否已经配置',
      children: [{
        id: '102-5-1',
        title: '102.5.1 客户端存活时间间隔',
        desc: '修复方式：clientaliveinterval 设置为大于 0 小于等于 300 之间的数值',
        commands: [
          'vim /etc/ssh/sshd_config',
          '#打开文件找到 clientaliveinterval 取消注释并设置为 300 wq 保存'
        ]
      }, {
        id: '102-5-2',
        title: '102.5.2 客户端连接最大数量',
        desc: '修复方式：ClientAliveCountMax 设置为小于等于 3',
        commands: [
          'vim /etc/ssh/sshd_config',
          '#打开文件找到 ClientAliveCountMax 取消注释并设置为 3 wq 保存'
        ]
      }]
    }, {
      id: '103',
      title: '103、PAM 类(Pluggable Authentication Modules)即可插拔式认证模块',
      children: [{
        id: '103-1',
        title: '103.1 密码配置',
        children: [{
          id: '103-1-1',
          title: '103.1.1 密码长度检测',
          desc: '修复方式：minlen 属性设置为大于等于 14',
          commands: [
            'vim /etc/security/pwquality.conf',
            '#打开文件找到 minlen 取消注释并设置为 14 wq 保存'
          ]
        }, {
          id: '103-1-2',
          title: '103.1.2 密码字符种类检测',
          desc: '修复方式：minclass 设置为大于等于 4',
          commands: [
            'vim /etc/security/pwquality.conf',
            '#打开文件找到 minclass 取消注释并设置为 4 wq 保存'
          ]
        }, {
          id: '103-1-3',
          title: '103.1.3 password-auth 密码重试次数',
          desc: '修复方式：try_first_pass retry=3',
          commands: [
            'vim /etc/pam.d/password-auth',
            '#打开文件找到 try_first_pass retry 取消注释并设置为 3 wq 保存'
          ]
        }, {
          id: '103-1-4',
          title: '103.1.4 system-auth 密码重试次数',
          desc: '修复方式：try_first_pass retry=3',
          commands: [
            'vim /etc/pam.d/system-auth',
            '#打开文件找到 try_first_pass retry 取消注释并设置为 3 wq 保存'
          ]
        }]
      }, {
        id: '103-2',
        title: '103.2 系统敏感文件权限配置',
        children: [{
          id: '103-2-1',
          title: '103.2.1 用户信息检测',
          commands: [
            'sudo chmod 644 /etc/passwd',
            'sudo chown root /etc/passwd',
            'sudo chgrp root /etc/passwd'
          ]
        }, {
          id: '103-2-2',
          title: '103.2.2 用户密码映射文件检测',
          commands: [
            'sudo chmod 640 /etc/shadow',
            'sudo chown root /etc/shadow',
            'sudo chgrp shadow /etc/shadow'
          ]
        }, {
          id: '103-2-3',
          title: '103.2.3 组信息检测',
          commands: [
            'sudo chmod 644 /etc/group',
            'sudo chown root /etc/group',
            'sudo chgrp root /etc/group'
          ]
        }, {
          id: '103-2-4',
          title: '103.2.4 组密码映射检测',
          commands: [
            'sudo chmod 640 /etc/gshadow',
            'sudo chown root /etc/gshadow',
            'sudo chgrp shadow /etc/gshadow'
          ]
        }, {
          id: '103-2-5',
          title: '103.2.5 用户信息备份检测',
          commands: [
            'sudo chmod 644 /etc/passwd',
            'sudo chown root /etc/passwd',
            'sudo chgrp root /etc/passwd'
          ]
        }, {
          id: '103-2-6',
          title: '103.2.6 用户密码映射文件备份检测',
          commands: [
            'sudo chmod 640 /etc/shadow-',
            'sudo chown root /etc/shadow-',
            'sudo chgrp shadow /etc/shadow-'
          ]
        }, {
          id: '103-2-7',
          title: '103.2.7 组信息备份检测',
          commands: [
            'sudo chmod 640 /etc/group-',
            'sudo chown root /etc/group-',
            'sudo chgrp root /etc/group-'
          ]
        }, {
          id: '103-2-8',
          title: '103.2.8 组密码信息映射文件备份检测',
          commands: [
            'sudo chmod 640 /etc/gshadow-',
            'sudo chown root /etc/gshadow-',
            'sudo chgrp shadow /etc/gshadow-'
          ]
        }]
      }]
    }, {
      id: '104',
      title: '104、系统安全相关',
      children: [{
        id: '104-1',
        title: '104.1 X86 指令集处理器 XD/NX 是否启用',
        children: [{
          id: '104-1-1',
          title: '104.1.1 不可执行保护检测开启',
          desc: '修复方式：在 BIOS 开启',
          images: ['linux-104-1-1.png']
        }]
      }, {
        id: '104-2',
        title: '104.2 ASLR是否配置',
        children: [{
          id: '104-2-1',
          title: '104.2.1 内核地址随机化检测',
          commands: [
            '/etc/sysctl.conf 追加 kernel.randomize_va_space = 2',
            'sudo sysctl -p',
          ]
        }]
      }]
    }]
  }
]
